import React from "react";
import { Box, Button } from "@mui/material";
import { theme } from "../../theme/colors";

const BASE_TABS = [
  { id: "civic", label: "Dashboard" },
  { id: "posts", label: "Posts" },
  { id: "badges", label: "Badges" },
];

export default function DashboardTabs({ activeTab, onTabChange, showEventsTab = false }) {
  const tabs = showEventsTab ? [...BASE_TABS, { id: "events", label: "Events" }] : BASE_TABS;

  return (
    <Box
      sx={{
        mt: 2,
        mb: 3,
        p: 0.5,
        display: "flex",
        gap: 0.5,
        width: "100%",
        overflowX: "auto",
        borderRadius: 3,
        backgroundColor: "#f1f5f9",
      }}
    >
      {tabs.map((tab) => {
        const selected = activeTab === tab.id;
        return (
          <Button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            sx={{
              flex: 1,
              minWidth: 120,
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: selected ? 700 : 600,
              textTransform: "none",
              color: selected ? theme.primary : "#0f172a",
              backgroundColor: selected ? "#ffffff" : "transparent",
              boxShadow: selected ? "0 1px 4px rgba(15, 23, 42, 0.08)" : "none",
              "&:hover": {
                backgroundColor: selected ? "#ffffff" : "rgba(255,255,255,0.55)",
              },
            }}
          >
            {tab.label}
          </Button>
        );
      })}
    </Box>
  );
}
